import { render, staticRenderFns } from "./MarkTheoryPaper.vue?vue&type=template&id=59a94848&scoped=true&"
import script from "./MarkTheoryPaper.vue?vue&type=script&lang=js&"
export * from "./MarkTheoryPaper.vue?vue&type=script&lang=js&"
import style0 from "./MarkTheoryPaper.vue?vue&type=style&index=0&id=59a94848&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a94848",
  null
  
)

export default component.exports